import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=033abbb7&scoped=true&"
import script from "./MessageList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MessageList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=033abbb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033abbb7",
  null
  
)

export default component.exports